import { ExternalLink } from 'lucide-react';
import NextLink from 'next/link';
import { useMemo } from 'react';

import { Badge, KeyValueRow, KeyValueTable, Text } from '@/design-system/components/ui';

import { Trigger } from '../../domain';

interface Props {
  trigger: Trigger;
}

export function XRepostTriggerFullDetails({ trigger }: Props) {
  const postId = useMemo(() => {
    if (trigger.context?.postId) {
      return trigger.context.postId;
    }
    if (!trigger.signature) return '';
    const match = trigger.signature.match(/^x-verify-retweet-(\d+)$/);
    return match ? match[1] : '';
  }, [trigger.context?.postId, trigger.signature]);

  const executedWhenDisplay = useMemo(() => {
    if (!/^\d+$/.test(postId)) return '-';

    const postUrl = `https://x.com/i/status/${postId}`;

    return (
      <div className="tw:flex tw:flex-row tw:gap-2 tw:items-center">
        <Text as="span" variant="body-sm" color="muted">
          User reposts
        </Text>
        <NextLink
          href={postUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="tw:flex tw:gap-0.5 tw:no-underline"
        >
          <Badge size="sm">
            <div className="tw:flex tw:flex-row tw:gap-1 tw:items-center">
              <span>View post</span>
              <ExternalLink size={12} />
            </div>
          </Badge>
        </NextLink>
      </div>
    );
  }, [postId]);

  return (
    <KeyValueTable>
      <KeyValueRow label="Name" value={trigger.name} />
      <KeyValueRow label="Description" value={trigger.description} />
      <KeyValueRow label="Executed when" value={executedWhenDisplay} />
      <KeyValueRow label="Argument conditions" value={trigger.conditionExpression ?? '-'} />
    </KeyValueTable>
  );
}
